import CourseController from '../diagrams/course.controller';
// import statesMockUp from './step-diagram-mockup';

class StepDiagramController extends CourseController {

  constructor(courseService, diagramService, $translate, $timeout, $sce, $scope, $compile) {
    'ngInject';

    super(courseService, diagramService, $translate);

    Object.assign(this, {$sce, $timeout, $scope, $compile});
    this.isStepDiagram = true
    this.currentStateNumber = 0;
    this.isFirst = true;
    this.isBlinkingAnimation = false;
    this.showPyramid = true;
    this.showSchoolSolutionPyramid = false;
    this.$scope.pyramidQuestion = '';
    this.modelValues = {
      title: '',
      s: '',
      c: '',
      q: '',
      pyramidQuestion: '',
      pyramidHeader: '',
      paper: ''
    }
    this.model = {}
  }

  $onInit() {
    // const arrayOfKeys = ['pyramid','s','c','q','title','number'];
    // const newStates = Object.assign({}, statesMockUp[this.lang], this.data);
    // newStates.tasks = statesMockUp[this.lang].tasks.map((item, index) => {
    //   const state = Object.assign({}, item, this.data.tasks[index]);
    //   arrayOfKeys.forEach((key) => {
    //     Object.assign(state[key], item[key]);
    //   });
    //   return state;
    // });
    // this.data = newStates;
    this.diagramId = this.data.id
    this.clearDiagramId = this.diagramId.replace('exercise', '')
    this.correctPaperAnswer = this.$sce.trustAsHtml(this.data.correctPaperAnswer);
    this.connectors = this.$sce.trustAsHtml(this.data.connectors);
    this.changeState();
    this.$timeout(() => {
      this.insertPyramidBody();
      }, 100);
    if (this.data.waitPyramidQuestionInput) {
      this.scqTogglerWhenWaitInput = {};
      const scq = ['s','c','q'];
      scq.forEach((item) => {
        this.scqTogglerWhenWaitInput[item] = false;
      });
      this.watching = this.$scope.$watch('pyramidQuestion', () => {
        if (this.$scope.pyramidQuestion.length >= 3) {
          scq.forEach((item) => {
            this.scqTogglerWhenWaitInput[item] = true;
            this.currentStateNumber !== 0 && this.shouldSCQShowAnswer(item);
          });
        } else {
          scq.forEach((item) => {
            this.scqTogglerWhenWaitInput[item] = false;
            this.currentStateNumber !== 0 && this.shouldSCQShowAnswer(item);
          });
        }
      });
    }
    super.$onInit()
  }

  shouldSCQShowAnswer(field) {
    if ((this[field].showInput && !this.data.waitPyramidQuestionInput)
      || (this.data.waitPyramidQuestionInput && this.currentStateNumber >= 7 && this.scqTogglerWhenWaitInput[field])
      || (this.data.waitPyramidQuestionInput && this.currentStateNumber < 7 && this[field].showInput)) {

      this[field].showInput = false;
    } else {
      this[field].showInput = true;
    }
  }


  $onDestroy() {
    super.$onDestroy();
    if (typeof this.watching === 'function') {
      this.watching();
    }
  }

  prev() {
      if (this.currentStateNumber > 1) {
          this.currentStateNumber--;
          this.changeState();
      }
  }

  next() {
      if ((this.currentStateNumber + 1) !== this.data.tasks.length) {
          this.currentStateNumber++;
          this.changeState();
      }
  }

  toogleadditionalInfoBox(additionalInfoBox) {
    if (additionalInfoBox.text !== this.additionalInfoBox.text) {
      this.additionalInfoBox.style = {
        'animation-name': !additionalInfoBox.text ? 'fadeOut' : 'fadeIn',
        'animation-duration': '1s',
        'animation-fill-mode': 'forwards'
      }

      this.$timeout(() => {
        this.additionalInfoBox.text = additionalInfoBox.text;
      }, !additionalInfoBox.text ? 100 : 0);
    }
  }

  showStudentAnswer(input, show, object) {
    const pyramidQuestionLengthValid = this.data.waitPyramidQuestionInput ? this.$scope.pyramidQuestion.length >= 3 : true;
    const shouldUpdate = this.checkAnswer && this.checkAnswer[input] && pyramidQuestionLengthValid;
    if (object && shouldUpdate) {
      this[input].showInput = show;
    } else if (shouldUpdate || (input === 'showPyramidQuestionField' && this.currentStateNumber >= 8)) {
      this[input] = show;
    }
  }

  showPyramidHead(status) {
    if (!this.pyramid.headerAnswer) {
      return
    }
    this.showSchoolSolutionPyramid = status
  }

  handleDiagramClick(event) {
    if (this.isBlinkingEffect && event.target.tagName.toLowerCase() !== 'textarea' && !event.target.classList.contains('step__diagram-slider__button')) {
      this.isBlinkingAnimation = true
      setTimeout(() => {
        this.isBlinkingAnimation = false
        this.$scope.$apply()
      }, 2000)
    }
  }

  changeState() {
      const newState = Object.assign({}, this.data.tasks[this.currentStateNumber]);
      Object.assign(this.model, {..._.cloneDeep(newState), modelValues: this.modelValues})
      if (newState.isLast) {
        this.onFinish({
          $event: {
            diagram: this.clearDiagramId,
            attempts: 0,
            hintsUsed: 0,
            rightAnswers: 0,
            userAnswers: this.model
          }
        })
      }
      if (!newState.isFirst) {
          this.animate(newState);
          const {isFirst, isLast, showSoWhatText, isBlinkingEffect, pyramidQuestion, showPyramid, pyramidDelay, arrows, rightArrows, hideInfoBox, endText, additionalInfoBox, showAditionalBox, showPyramidQuestionField, checkAnswer, showDocument} = newState;

          Object.assign(this, {
            isFirst,
            isLast,
            isBlinkingEffect,
            pyramidQuestion,
            showAditionalBox,
            checkAnswer,
            showDocument,
            showPyramidQuestionField,
            showSoWhatText,
            arrows: this.$sce.trustAsHtml(arrows),
            rightArrows: this.$sce.trustAsHtml(rightArrows)
          });

          this.$timeout.cancel(this.showPyramidTimeout);
          this.$timeout.cancel(this.showEndTextTimeout);

          if (showPyramid && pyramidDelay) {
            this.showPyramidTimeout = this.$timeout(() => {
              this.showPyramid = showPyramid;

              this.$scope.$apply();
            }, pyramidDelay);
          } else {
            Object.assign(this, {showPyramid});
          }

          if (hideInfoBox && endText.delay) {
            this.showEndTextTimeout = this.$timeout(() => {
              Object.assign(this, {hideInfoBox, endText});
              this.showPyramid = showPyramid;

              this.$scope.$apply();
            }, endText.delay);
          } else {
            Object.assign(this, {hideInfoBox, endText});
          }

          if (additionalInfoBox) {
            this.toogleadditionalInfoBox(additionalInfoBox);
          }

          if (this.data.waitPyramidQuestionInput && this.currentStateNumber < 7) {
            this.$scope.pyramidQuestion = '';
          }
      } else {
          Object.assign(this, newState);
      }
  }

  insertPyramidBody() {
    const pyramidBlocksWrapper = angular.element(`#${this.data.id} .pyramid-blocks`);
    pyramidBlocksWrapper.html(this.data.pyramidBlocks);
    this.$compile(pyramidBlocksWrapper)(this.$scope);
    this.$timeout(() => {
      this.showPyramidBody = true;
    }, 0)
  }

  checkSCQInputShow(key, keyObject) {
    const validKey = ['s', 'c', 'q', 'pyramid', 'title'];
    if (validKey.includes(key) && keyObject.showInput) {
      if (this.data.waitPyramidQuestionInput && this.currentStateNumber >= 7 && this.$scope.pyramidQuestion.length >= 3) {
        this[key].showInput = false;
      } else {
        this[key].showInput = true;
      }

      if (key === 'title') {
        this[key].rows = keyObject.rows;
      }
    } else {
      this[key].showInput = false;
    }
  }

  animate(newState) {
    const exceptions = ['arrows', 'isFirst', 'isLast', 'isBlinkingEffect', 'pyramidQuestion', 'rightArrows', 'pyramidDelay', 'hideInfoBox', 'endText', 'additionalInfoBox', 'showAditionalBox', 'showPyramidQuestionField', 'checkAnswer', 'showDocument'];

      for (const key in newState) {
          if (!exceptions.includes(key)) {
            if (key === 'pyramid') {
              if (newState[key].headerAnswer) {
                this[key].headerAnswer = newState[key].headerAnswer
                this[key].hideText = newState[key].hideText || false
                this.showSchoolSolutionPyramid = true
              } else {
                this[key].headerAnswer = ''
                this[key].hideText = false
                this.showSchoolSolutionPyramid = false
              }
            }
              if ((this[key].text === '') && (newState[key].text !== '')) {
                  this.checkSCQInputShow(key, newState[key]);
                  this[key].text = newState[key].text;
                  this.$timeout(() => {
                      this[key].style = {
                          'animation-name': key !== 'pyramid' ? 'fadeIn' : 'slideIn',
                          'animation-duration': '0.5s',
                          'animation-fill-mode': 'forwards'
                      }
                  }, newState[key].delay);
              } else if (this[key].text !== newState[key].text) {
                  this.$timeout(() => {
                      this[key].style = {
                          'animation-name': key !== 'pyramid' ? 'fadeOut' : 'slideOut',
                          'animation-duration': '0.5s',
                          'animation-fill-mode': 'forwards'
                      }
                      this.$timeout(() => {
                        this.checkSCQInputShow(key, newState[key]);
                        this[key].text = newState[key].text;
                        this[key].style = {
                          'animation-name': key !== 'pyramid' ? 'fadeIn' : 'slideIn',
                          'animation-duration': '0.5s',
                          'animation-fill-mode': 'forwards'
                        }
                      }, 500);
                  }, newState[key].delay);
              } else if (newState[key].showInput) {
                this.checkSCQInputShow(key, newState[key]);
              }
          }
      }
  }
}
export default StepDiagramController;



// WEBPACK FOOTER //
// ./client/app/components/step-diagram/step-diagram.controller.js